
import { Vue, Component } from "vue-property-decorator";
import editor from "./editor";
import { translit } from "@/cms-services/helpers";
import axios from "axios";
@Component({
  mixins: [editor],
})
export default class SystemNameInlineEditor extends Vue {
  dataSource: any;
  value: any;
  config: any;
  save: any;
  $message: any;

  /**
   * Системное имя — адрес страницы, повторы запрещены на уровне базы.
   * Сервер на отказ отвечает фразой про «inner exception», человеку непонятно:
   * один и тот же врач сохранялся девять раз подряд и каждый раз получал отказ.
   * Поэтому проверяем занятость заранее и говорим, кем имя занято.
   */
  async saveChecked() {
    const next = String(this.value ?? "").trim();
    const className = this.dataSource?.className ?? this.dataSource?.model?.className;
    const id = Number(this.dataSource?.model?.id);

    if (next && className) {
      try {
        // адрес без префикса: у axios в админке базовый путь уже /api/v1/
        const { data } = await axios.get(`/manage/${className}`, {
          params: {
            pageIndex: 1,
            pageSize: 5,
            filter: JSON.stringify([{ fieldName: "name", fieldValue: next }]),
          },
        });
        const clash = (data?.items ?? []).find((x: any) => Number(x.id) !== id);
        if (clash) {
          const who = clash.caption ?? clash.name ?? `ID ${clash.id}`;
          this.$message(`Системное имя «${next}» уже занято: ${who}. Выберите другое.`, "error");
          return;
        }
      } catch (e) {
        // проверка не удалась — отдаём серверу как раньше
      }
    }
    await this.save();
  }
  generateSystemName() {
    const bindedFieldName = this.config?.bindedFieldName ?? "caption";
    const caption = this.dataSource?.model[bindedFieldName];
    if (!caption) return;
    this.value = translit(caption);
  }
}
